import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9f69ee4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "block-item-tab-wrap" }
const _hoisted_2 = { class: "block-item-tab" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "block-item-tab-text block-item-tab-text-link" }

import {useRouter} from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'block-item-tab',
  props: {
  /** Заголовок  */
  text: {
    type: String,
    default: "",
  },
  pl: {
    type: String,
    default: "40px",
  },
  image: {
    type: String,
    default: "",
  },
  id: {
    type: Number,
    default: 0,
  },
  link: {
    type: String,
    default: "",
  },
  scrollHash: {
    type: String,
    default: "",
  },
},
  setup(__props) {

const props = __props;

_useCssVars(_ctx => ({
  "0148f65e": (__props.pl)
}))

const router = useRouter();




return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "block-item-tab-image",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({name: __props.link, hash:__props.scrollHash})))
      }, [
        _createElementVNode("img", {
          src: __props.image,
          alt: "image"
        }, null, 8, _hoisted_3)
      ]),
      _withDirectives(_createElementVNode("div", { class: "block-item-tab-text" }, _toDisplayString(__props.text), 513), [
        [_vShow, !(__props.link!='' || __props.scrollHash!='')]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_4, [
        _createVNode(_component_router_link, {
          to: {name:__props.link, hash:__props.scrollHash},
          style: {"text-decoration":"none","color":"inherit"}
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.text), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ], 512), [
        [_vShow, (__props.link!='' || __props.scrollHash!='')]
      ])
    ])
  ]))
}
}

})